/**
 * @file AuthCallback.jsx
 * @description Callback view displayed during the Google OAuth authentication redirect process.
 * @module components/AuthCallback
 */
import React, { useEffect } from 'react';
import { FiLoader } from 'react-icons/fi';

/* ══════════════════════════════════════════════════════════════
 * MAIN COMPONENT
 * ══════════════════════════════════════════════════════════════ */

/**
 * @component AuthCallback
 * @description Renders a secure, branded loading state while the authentication 
 *              token is being processed by Supabase and the AuthContext.
 *
 * @returns {JSX.Element} The rendered Authentication Callback loader.
 */

const AuthCallback = () => {
    // ── Component State ──
    
    useEffect(() => {
        document.title = "SimpleCode | Authenticating...";
        return () => {
            document.title = "SimpleCode";
        };
    }, []);
    return (
        <div className="min-h-screen bg-emerald-800 flex flex-col items-center justify-center font-sans p-4">
            {/* Logo area */}
            <div className="mb-10 animate-in fade-in slide-in-from-top-4 duration-1000">
                <img
                    src="/logo.png"
                    alt="SimpleCode"
                    className="h-10 sm:h-12 w-auto"
                />
            </div>

            <div className="flex flex-col items-center space-y-6 animate-in fade-in zoom-in-95 duration-700">
                <FiLoader className="text-5xl text-white animate-spin" />
                
                <div className="text-center space-y-2">
                    <h2 className="text-2xl font-medium text-white tracking-wide">
                        Authenticating...
                    </h2>
                    <p className="text-emerald-100/80 text-sm max-w-sm px-2">
                        Please wait while we securely sign you in with Google.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default AuthCallback;
